import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { closeAuth, setAuthView, setGuestMode } from '../../redux/slice/authModalSlice';
import { setGuestModeInStorage } from '../../helper/helper';
import type { AuthView } from './types/auth.d.ts';
import Login from './Login';
import Signup from './Signup';
import ForgotPassword from './ForgotPassword';
import OtpModal from './OtpModal';
import NewPassword from './NewPassword';
import MultipleUsers from './MultipleUsers';
import ProfileSetup from './ProfileSetup';

const AuthModalManager: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen, view } = useAppSelector((s) => s.authModal);

  useEffect(() => {
    if (isOpen && location.pathname !== '/login') {
      dispatch(closeAuth());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (!isOpen || view === 'closed') return null;

  const go = (next: AuthView) => dispatch(setAuthView(next));

  switch (view) {
    case 'signin':
      return (
        <Login
          onLogin={() => {}}
          onGuestMode={() => {
            dispatch(setGuestMode(true));
            setGuestModeInStorage(true); // Persist to localStorage
            dispatch(closeAuth());
            // Navigate to home after guest mode (using React Router)
            navigate('/', { replace: true });
          }}
          onSignUp={() => go('signup')}
        />
      );
    case 'signup':
      return <Signup />;
    case 'forgot':
      return <ForgotPassword />;
    case 'otp':
      return <OtpModal />;
    case 'newPassword':
      return <NewPassword />;
    case 'multipleUsers':
      return <MultipleUsers />;
    case 'profileSetup':
      return <ProfileSetup />;
    default:
      return null;
  }
};

export default AuthModalManager;


